import IRepresentativeRepository from 'domain/interfaces/repositories/IRepresentativeRepository'
import { Query } from 'domain/models/query'

export const readStudentsByRepresentativeQuery = (
  repository: IRepresentativeRepository,
  query?: Query,
) => {
  return repository.getStudentsByRepresentative(query)
}
